module.exports = __webpack_public_path__ + "img/Christmas-text.7c7b6327.jpg";